export const TRANSPORTS = ['any', 'bus', 'plane', 'own'];
export const TRANSPORT_DEFAULT = 'plane';
export const ADULTS_MIN = 1;
export const ADULTS_MAX = 9;
export const ADULTS_DEFAULT = 2;
export const CHILDREN_MIN = 0;
export const CHILDREN_MAX = 6;
export const CHILDREN_MIN_AGE = 0;
export const CHILDREN_MAX_AGE = 16;
export const CHILDREN_DEFAULT = [];
export const AUTOCOMPLETE_MIN_VALUE_LENGTH = 3;
export const AUTOCOMPLETE_DELAY_TIME = 500;
export const LANGUAGE_DEFAULT = 'pl';
export const FORM_FILTERS = ['all_inclusive', 'last_minute'];
export const CHARTERS_DIRECTION_BOTH_WAY = 'bothWay';
export const CHARTERS_DIRECTION_ONE_WAY = 'oneWay';
export const TRANSPORT_CHARTER_TYPE = 'czarter';
